export const LAB_FIELD_QUERY_KEY = 'labFieldValues' as const;

export const labFieldKeys = {
  all: [LAB_FIELD_QUERY_KEY] as const
} as const;
